// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Учасники» (Members, ключ `mbr`, група `party-and-group`). */
export const membersManifest: IModuleManifest = {
  key: 'mbr',
  group: 'party-and-group',
  slug: 'members',
  prefix: 'MBR',
  name: { en: 'Members', uk: 'Учасники' },
  entities: [
    { key: 'mbr', slug: 'mbr', name: { en: 'Members', uk: 'Учасники' }, main: true },
    { key: 'brn', slug: 'brn', name: { en: 'Branches', uk: 'Осередки' }, main: false },
    { key: 'member_application', slug: 'member-application', name: { en: 'Member Applications', uk: 'Заяви про вступ' }, main: false },
    { key: 'member_role', slug: 'member-role', name: { en: 'Member Roles', uk: 'Ролі' }, main: false },
    { key: 'member_dues_payment', slug: 'member-dues-payment', name: { en: 'Member Dues Payments', uk: 'Членські внески' }, main: false },
  ],
  loadState: () => import('./state/membersSlice').then((m) => m.membersSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
